export default __webpack_public_path__ + "static/media/Group 3174@2x.d6f3444f.png";